import { LeftIcon } from "assets/icons";
import BottomSheet from "components/foundation/BottomSheet/BottomSheet";
import SearchInput from "components/foundation/SearchInput/SearchInput";
import Select from "components/foundation/Select/Select";
import React, { useState } from "react";
import styled from "styled-components";
import { Table } from "./Table";
import { Controller, useFormContext } from "react-hook-form";

interface SearchButtonMobileProps {
  children?: React.ReactNode;
  searchType?: {
    value: string;
    label: string;
  }[];
  autocomplete?: {
    value: string;
    label: string;
  }[];
}

interface FormData {
  searchType: string;
}
const TableInputMobile = ({
  children,
  searchType,
  autocomplete,
}: SearchButtonMobileProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const { control } = useFormContext<FormData>();

  const handleToggle = () => {
    setIsOpen((prev) => !prev);
  };

  const handleDropdownToggle = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  return (
    <>
      <TableInputMobileButton
        variant="tertiary"
        size="small"
        onClick={handleToggle}
      >
        {children}
      </TableInputMobileButton>
      {isOpen && (
        <>
          <InputFelidLayout>
            <LeftIcon onClick={handleToggle} />
            {searchType && (
              <Controller
                control={control}
                name="searchType"
                render={({ field: { onChange, value } }) => (
                  <Select
                    placeholder="태그"
                    style={{
                      width: "10rem",
                    }}
                    list={searchType}
                    onValueChange={onChange}
                    value={value}
                  />
                )}
              />
            )}
            <SearchInput
              iconPosition="right"
              style={{
                flex: 1,
              }}
              autocomplete={autocomplete}
            />
          </InputFelidLayout>

          <BottomSheet
            isOpen={isDropdownOpen}
            setOpen={setIsDropdownOpen}
            title={"검색조건"}
          >
            {searchType?.map((item) => (
              <Controller
                key={item.value}
                control={control}
                name="searchType"
                render={({ field: { onChange } }) => (
                  <div
                    key={item.value}
                    onClick={() => {
                      onChange(item.value);
                      handleDropdownToggle();
                    }}
                  >
                    {item.label}
                  </div>
                )}
              />
            ))}
          </BottomSheet>
        </>
      )}
    </>
  );
};

export default TableInputMobile;

export const TableInputMobileButton = styled(Table.Button)`
  display: flex;
  gap: 0.4rem;
  align-items: center;
  padding: 0.4rem 1rem;
`;

const InputFelidLayout = styled.div`
  display: flex;
  gap: 0.4rem;
  align-items: center;
  padding: 0.5rem 1.6rem;

  position: fixed;
  width: 100%;
  background-color: ${({ theme }) => theme.color.white};
  top: 0;
  left: 0;

  z-index: ${({ theme }) => theme.zIndex.searchBar};

  svg {
    cursor: pointer;
  }
`;
